<template>
    <main>
        <section>
            <div class="content-960">
                <div class="row">
                    <section class="col-sm-12">
                        <button class="btn-large-40 btn-primary uppercase pull-right btn-header" style="margin-left: 10px;" @click="openCreate()">
                            Criar
                        </button>
                        <button class="btn-large-40 btn-success uppercase pull-right btn-header" @click="openBatchCreate()">
                            Criar em Lote
                        </button>
                    </section>
                </div>
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Instituição de Ensino Estágio</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form v-on:submit.prevent="executeFilter(filter)">
                            <div class="row">
                                <div class="form-group col-md-12">
                                    <label for="estagioId">Estágio</label>
                                    <select v-select="{ dataitem: 'Estagio', default: 'Selecione' }" v-model="filter.estagioId" class="form-control" name="estagioId"></select>
                                </div>

                                <div class="form-group col-md-4">
                                    <label>Venda Liberada</label>
                                    <div class="form-group">
                                        <label class="custom-control custom-radio">
                                            <input type="radio" name="vendaLiberada" v-model="filter.vendaLiberada" value="undefined" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Todos</span>
                                        </label>
                                        <label class="custom-control custom-radio">
                                            <input type="radio" name="vendaLiberada" v-model="filter.vendaLiberada" value="true" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Sim</span>
                                        </label>
                                        <label class="custom-control custom-radio">
                                            <input type="radio" name="vendaLiberada" v-model="filter.vendaLiberada" value="false" class="custom-control-input">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description">Não</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="valorMaterialDidaticoInstituicao">Valor Material Didático Instituicao</label>
                                    <input type="number" class="form-control" name="valorMaterialDidaticoInstituicao" placeholder="ValorMaterialDidaticoInstituicao" v-model="filter.valorMaterialDidaticoInstituicao" />
                                </div>
                                <div class="form-group col-md-4">
                                    <label for="valorMaterialDidaticoAluno">Valor Material Didático Aluno</label>
                                    <input type="number" class="form-control" name="valorMaterialDidaticoAluno" placeholder="ValorMaterialDidaticoAluno" v-model="filter.valorMaterialDidaticoAluno" />
                                </div>

                            </div>
                            <button type="button" class="btn-large-40 btn-red uppercase" @click="executeFilter(filter)">Buscar</button>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>Estágio<i @click="executeOrderBy('VendaLiberada')" class="fa fa-sort"></i></th>
                                    <th>Venda Liberada<i @click="executeOrderBy('Estagio')" class="fa fa-sort"></i></th>
                                    <th>Valor Material Didático Instituição<i @click="executeOrderBy('ValorMaterialDidaticoInstituicao')" class="fa fa-sort"></i></th>
                                    <th>Valor Material Didático Aluno<i @click="executeOrderBy('ValorMaterialDidaticoAluno')" class="fa fa-sort"></i></th>

                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{ item.estagio ? item.estagio.nome : '' }}</td>   
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.vendaLiberada, 'badge-danger': !item.vendaLiberada }">{{item.vendaLiberada ? 'Sim' : 'Não'}}</span></td>
                                    <td>{{ formatPrice(item.valorMaterialDidaticoInstituicao) }}</td>
                                    <td>{{ formatPrice(item.valorMaterialDidaticoAluno) }}</td>

                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-primary" @click="openEdit({ instituicaoEnsinoEstagioId: item.instituicaoEnsinoEstagioId })">
                                            <i class="fa fa-pencil"></i>
                                        </button>
                                        <button type="button" class="btn btn-sm btn-danger" @click="openRemove({ instituicaoEnsinoEstagioId: item.instituicaoEnsinoEstagioId })">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create :id="id" v-if="dialogCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogBatchCreate" :hide-footer="true" title="Criar em Lote">
            <form-batch-create :id="id" v-if="dialogBatchCreate" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="instituicaoEnsinoEstagioId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formBatchCreate from './form-batch-create'
    import formEdit from './form-edit'

    export default {
        name: 'instituicaoensinoestagio',
        mixins: [base],
        props: { id: Number },
        components: { formCreate, formBatchCreate, formEdit },
        data() {
            return {

                resources: {
                    filter: 'instituicaoensinoestagio',
                    remove: 'instituicaoensinoestagio'
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogBatchCreate: false,
                dialogEdit: false,

                model: {},
                filter: {
                    instituicaoEnsino: {},
                    estagio: {},
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openEdit: function (model) {
                this.instituicaoEnsinoEstagioId = model.instituicaoEnsinoEstagioId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            openBatchCreate: function () {
                this.dialogBatchCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogBatchCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
            },

            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();   

                this.filter.instituicaoEnsinoId = this.id;
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },

        },

        mounted() {
            this.executeFilter();
        }

    };
</script>